var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b-toast-user"},[_c('UserBlock',{attrs:{"id":_vm.userid,"encryptedkey":_vm.userdisplay}}),_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }